import angular from 'angular';
import moment from 'moment-timezone';

module.exports = angular.module('common.filters.moment-from-now', [])
.filter('momentFromNow', function() {
  return function(m) {
    return moment(m).fromNow();
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/moment-from-now.js
 **/